import lodash from 'lodash'
import { BindAll } from 'lodash-decorators'
import { EnumApiCurrency } from '../../api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { Toast } from 'vant'
import { $service } from '@xt/client/experimental/request/service'
declare const WxLogin: any
@BindAll()
export class ControllerWechat {
  constructor(
    protected $ajax: AjaxBasics,
    protected appId
  ) {
    // 提前加载WEIXINJSSDK
    try {
      // @ts-expect-error
      if (wx) this.onInit()
    } catch (_) {}
  }
  get WeixinJSBridge() {
    if (wx) {
      return wx
    }
    return undefined
  }
  isReady = false
  loading = false
  jsApiList = [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    // 'onMenuShareWeibo',
    // 'onMenuShareQZone',
    // 'startRecord',
    // 'stopRecord',
    // 'onVoiceRecordEnd',
    // 'playVoice',
    // 'pauseVoice',
    // 'stopVoice',
    // 'onVoicePlayEnd',
    // 'uploadVoice',
    // 'downloadVoice',
    'chooseImage',
    // 'previewImage',
    'uploadImage',
    // 'downloadImage',
    // 'translateVoice',
    // 'getNetworkType',
    // 'openLocation',
    // 'getLocation',
    // 'hideOptionMenu',
    // 'showOptionMenu',
    // 'hideMenuItems',
    'showMenuItems',
    // 'hideAllNonBaseMenuItem',
    // 'showAllNonBaseMenuItem',
    // 'closeWindow',
    // 'scanQRCode',
    'chooseWXPay',
    'openAddress'
    // 'openProductSpecificView',
    // 'addCard',
    // 'chooseCard',
    // 'openCard'
  ]
  openTagList = ['wx-open-launch-weapp']
  Promise: Promise<any>
  /**
   * 初始化
   * @param appId
   */
  async onInit(debug = false) {
    try {
      if (this.isReady) {
        return this.WeixinJSBridge
      }
      if (!this.loading) {
        this.loading = true
        const url = window['__xt__href'].split('#')[0]
        const [err, res] = await $service({
          url: EnumApiCurrency.wxmp,
          params: { url },
          headers: { Authorization: 'Basic dXNlci1jbGllbnQ6dXNlci1zZWNyZXQtODg4OA==' }
        })
        if (err) throw err
        const config = lodash.merge(
          {
            debug: debug,
            appId: this.appId,
            jsApiList: this.jsApiList,
            openTagList: this.openTagList
          },
          res
        )
        return new Promise((resolve, reject) => {
          this.WeixinJSBridge!.config(config as any)
          this.WeixinJSBridge!.ready(() => {
            resolve(true)
          })
          wx.error(reject)
        })
      }
      this.isReady = true
    } catch (error) {
      console.log('LENG: ControllerWechat -> onInit -> error', error)
      this.isReady = false
    }
    return this.WeixinJSBridge
  }
  /**
   * 获取微信 open id
   * @param code
   */
  onGetOpenid(code) {
    return $service({ url: EnumApiCurrency.openid, params: { code, type: 2 }, responseType: 'text' })
  }
  // https://developers.weixin.qq.com/doc/oplatform/Website_App/WeChat_Login/Wechat_Login.html
  onWxLogin(id, appId, state = 'login', redirect_uri = window.location.origin, addCss?: string) {
    console.log('LENG ~ ControllerWechat ~ onWxLogin ~ redirect_uri', redirect_uri)
    new WxLogin({
      self_redirect: false,
      id: id,
      appid: appId,
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(redirect_uri),
      state: state,
      style: '',
      response_type: 'auth',
      href: !addCss
        ? 'data:text/css;base64,LyogLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMXB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30gKi8KLmltcG93ZXJCb3ggLnRpdGxlewogICAgZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICB3aWR0aDogMTY1cHg7CiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94OwogICAgbWFyZ2luLXRvcDogMDsKICAgIHBvc2l0aW9uOiByZWxhdGl2ZTsKICAgIHRvcDogLTEwcHg7CiAgICBsZWZ0OiAtMTBweDsKfQouaW1wb3dlckJveCAud3JwX2NvZGV7CiAgICB3aWR0aDoxNDhweDsKfQ=='
        : addCss
    })
  }

  /**
   * 授权 url https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html#0
   * @param redirect_uri
   */
  getAuthorizeUrl(redirect_uri, scope: 'snsapi_base' | 'snsapi_userinfo' = 'snsapi_userinfo', state = 'login') {
    console.log('LENG ~ ControllerWechat ~ redirect_uri', redirect_uri)
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${encodeURIComponent(
      redirect_uri
    )}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
  }
}
export default ControllerWechat
